/* eslint-disable camelcase */
import React, {ReactElement, useMemo, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT
import Paper from '@material-ui/core/Paper';
import ErrorIcon from '@material-ui/icons/Error';
import {
  APP,
  APP_PRIMARY_COLOR,
  BORDER_BOTTOM_COLOR,
  DEFAULT_BLACK_COLOR,
  LOADING_DARK_OVERLAY_COLOR
} from 'src/style/variable';
import {useTranslation} from 'react-i18next';
import {
  Grid,
  Select,
  Typography,
  Divider,
  MenuItem,
  ListItemText,
  Chip,
  Radio,
  RadioGroup,
  FormControlLabel,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton
} from '@material-ui/core';
import './AppointmentCardDetailsStyle.scss';
import EmrSyncStatusChip from '../EmrSync/components/EmrSyncStatusChip';
import ArrivalChip from '../EmrSync/components/ArrivalChip';
import {
  canMarkPatientUpdatedInEmr,
  isPatientAwaitingEmrPost,
  isPatientEmrSyncPending,
  showsPatientEmrSyncedChip
} from '../EmrSync/utils/patientEmrSyncStatus';
import {
  canMarkGuarantorUpdatedInEmr,
  isGuarantorAwaitingEmrPost,
  showsGuarantorEmrSyncedChip
} from '../EmrSync/utils/guarantorEmrSyncStatus';
import DropDownFieldValue from '@components/system/DropDownFieldValue/DropDownFieldValue';
import CheckIcon from '@material-ui/icons/Check';
import {ExpandLess, ExpandMore} from '@material-ui/icons';

import {
  patientForms,
  EligibilityStatusMapping,
  // EligibilityStatusObj,
  PatientsTabKeys,
  VerificationStatusMapping,
  VerificationStatusObj,
  AppPermissions,
  EligibilityStatusMappingObj,
  USER,
  EligibilityStatusObj,
  VaccineStatusMapping,
  AppointmentStatus,
  AppointmentSource,
  RMD_APPOINTMENT_STATUSES,
  RMD_APPOINTMENT_SOURCES,
  ClaimStatusMapping,
  ACHStatusMapping,
  CONSENT_METADATA_STATUS_MAPPER,
  APPOINTMENT_PATIENT_FEEDBACK
} from '@shared/constants/Mapping';
import CheckBoxField from '@components/system/CheckBox/CheckBoxField';
import {appointmentsDateTimeFormat} from '@shared/utils/DateTimeUtils';
import FormUtils from '@shared/utils/FormUtils';
import CustomSelectField from '../ClinicGroups/AddUser/CustomSelectField';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {useDispatch, useSelector} from 'react-redux';
import HelperUtils, {
  getAppointmentStatus,
  sanitizeEmrAlphanumericInput
} from '@shared/utils/HelperUtils';
import CurrencyFormatter from '@components/system/CurrencyFormatter/CurrencyFormatter';
import GuarantorDrawerComponent from '../Invoices/Drawer/GuarantorDrawerComponent';
import {
  _patientDrawerDetails,
  _setActiveTab,
  _setEligibilityVerificationAppointmentPatientDrawer
} from '@shared/store/actions/PatientDrawerAction';
import VerifyInsurance from '../Patients/Patientdetails/EligibilityVerification/VerifyInsurance';
import ManualVerificationModal from '../Patients/Patientdetails/EligibilityVerification/ManualVerificationModal';
import {CommunicationService} from 'src/service/CommunicationService';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {
  getAppointmentById,
  markAppointmentPostedToEmr,
  updateAppointment
} from '@shared/services/AppointmentsServices';
import {
  getSpecificPatientDetails,
  updatePatient
} from '@shared/services/PatientsServices';
import {useSnackbar} from 'notistack';
import Loader from '@components/framework/loader/Loader';
import {State} from '@shared/store/reducers/Index';
import {Permission} from '@shared/services/PermissionService';
import {
  getVaccineFileDataConsentForm,
  getVaccineRecordDetails,
  // getVaccineConsentForm,
  updateVaccineStatusAppointment
} from '@shared/services/AppointmentSchedulingService';
import ViewConsentFormDialog from './ViewConsentFormDialog/ViewConsentFormDialog';
import ReviewConsentFormDialog from './ReviewConsentFormDialog/ReviewConsentFormDialog';
import {
  remindAgain,
  updateGatherFeedBackAppointment
} from '@shared/services/GatherFeedbackServices';
import ReminderProcessIcon from '@components/system/MyIcons/ReminderProcessIcon';
import EligibilityVerificationLogs from './EligibilityVerificationLogs/EligibilityVerificationLogs';
import {formatApiMessage} from '@shared/utils/formatApiMessage';

function trimStr(v: unknown): string {
  if (v == null) return '';
  return String(v).trim();
}

/** True if we still need a claim/shipping-style address (primary or contact address on patient). */
function patientNeedsShippingAddress(p: any): boolean {
  if (!p) return true;
  const primaryComplete =
    trimStr(p.address_line_1) &&
    trimStr(p.city) &&
    trimStr(p.state) &&
    trimStr(p.zip_code ?? p.zip);
  if (primaryComplete) return false;
  const contactComplete =
    trimStr(p.contact_address_line_1) &&
    trimStr(p.contact_city) &&
    trimStr(p.contact_state) &&
    trimStr(p.contact_zip_code);
  return !contactComplete;
}

function mapFlatPatientDetailToEditPayload(
  flat: any,
  clinicId: number | string,
  addr: {
    address_line_1: string;
    city: string;
    state: string;
    zip_code: string;
  },
  fallbackPatient: any
) {
  const dobRaw = fallbackPatient?.dob ?? flat?.dob;
  const patientRow: Record<string, unknown> = {
    id: flat.patient_id,
    first_name: flat.first_name,
    middle_name: flat.middle_name,
    last_name: flat.last_name,
    account_number: flat.patient_account_number,
    cell_phone: flat.patient_phone,
    email: flat.email,
    address_line_1: addr.address_line_1,
    address_line_2: flat.patient_add_2,
    city: addr.city,
    state: addr.state,
    zip_code: addr.zip_code,
    gender: fallbackPatient?.gender,
    ssn: fallbackPatient?.ssn ?? ''
  };
  if (dobRaw != null && dobRaw !== '') {
    patientRow.dob = HelperUtils.formatDisplayDate(dobRaw);
  }
  return {
    clinic_id: clinicId,
    guarantor: {
      id: flat.guarantor_id,
      first_name: flat.guarantor_first_name,
      last_name: flat.guarantor_last_name,
      middle_name: flat.guarantor_middle_name,
      account_number: flat.guarantor_account_number,
      phone_1: flat.guarantor_phone,
      phone_2: flat.guarantor_phone_2,
      phone_3: flat.guarantor_phone_3,
      email: flat.guarantor_email,
      address_line_1: flat.guarantor_address_line_1,
      address_line_2: flat.guarantor_address_line_2,
      city: flat.guarantor_city,
      state: flat.guarantor_state,
      zip_code: flat.guarantor_zip_code
    },
    patients: [patientRow]
  };
}

const useStyles = makeStyles({
  secondaryCard: {
    height: '100%'
  },
  date: {
    fontSize: 10
  },
  title: {
    margin: '16px 0 8px',
    fontSize: 16
  },
  chipStyle: {
    color: APP.COLOR.DEFAULT.WHITE
  },
  chipStyleFn: {
    backgroundColor: APP.COLOR.NOTICE_TYPE.FN
  },
  chipStylePd: {
    backgroundColor: APP.COLOR.NOTICE_TYPE.PD
  },
  postedStatusButton: {
    marginTop: 12
  },
  pos: {
    fontSize: '0.625rem',
    marginTop: 12
  },
  subWrapper: {
    // marginLeft: '0.5rem',
    // marginTop: '0.5rem',
    // marginBottom: '0.5rem'
    margin: '0.5rem'
  },
  divSpacing: {
    marginTop: '2rem',
    marginLeft: '1rem',
    marginRight: '1rem',
    marginBottom: '1.5rem'
  },
  dividerSpacing: {
    marginRight: '1rem',
    marginLeft: '1rem'
  },
  refundAndReceiptButtonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '0.5rem',
    paddingRight: '1rem'
  },
  noteWidth: {
    minWidth: '35rem',
    '@media (min-width:0px) and (max-width:1024px)': {
      minWidth: '25rem'
    }
  },
  textUnderLine: {
    // textDecoration: 'underline'
  },
  dropDown: {
    cursor: 'pointer',
    alignItems: 'center'
    // color: APP_PRIMARY_COLOR
  },
  checkBoxGrid: {
    '&.MuiGrid-item': {
      paddingLeft: '1.7rem'
    },
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  checkBoxText: {
    marginTop: '0.2rem',
    marginLeft: '0.2rem'
  },
  checkboxControl: {
    '& .MuiFormControlLabel-label': {
      marginTop: '0.2rem',
      marginLeft: '0.2rem'
    }
  },
  clinicsDropDownWidth: {
    minWidth: '10rem',
    width: '100%'
  },
  root: {
    minWidth: '400px',
    '&:focus': {
      outline: 'none'
    }
  },
  ClinicFilterHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 16px'
  },
  ClinicMenu: {
    overflow: 'auto',
    '& li': {
      borderBottom: `1px solid ${BORDER_BOTTOM_COLOR}`
    },
    '& li:last-child': {
      borderBottom: 'none'
    }
  },
  secondary: {
    '& .MuiListItemText-secondary': {
      fontSize: '0.9rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  actionButtons: {
    justifyContent: 'flex-end',
    display: 'flex'
  },
  primary: {
    '& .MuiListItemText-primary': {
      fontSize: '1.2rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  clinicText: {
    fontSize: '1.3rem'
  },
  clearAll: {
    textTransform: 'capitalize',
    fontSize: '1rem'
  },
  LinkStyle: {
    whiteSpace: 'nowrap',
    lineHeight: '1.25rem',
    cursor: 'pointer',
    color: APP_PRIMARY_COLOR,
    textDecoration: 'underline'
  },
  appointmentTime: {
    fontWeight: 600,
    color: DEFAULT_BLACK_COLOR
  },
  bold: {
    fontWeight: 'bold'
  },
  loadingOverlay: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: LOADING_DARK_OVERLAY_COLOR,
    zIndex: 1
  },
  wrapLink: {
    whiteSpace: 'normal'
  },
  administerWrap: {
    '& .field-value-wrapper': {
      height: '100%',
      justifyContent: 'flex-end'
    }
  },
  consentFormFieldWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '0.3rem'
  },
  consentFormFieldAttention: {
    color: 'red',
    textDecoration: 'none',
    lineHeight: '1em'
  },
  guarantorInfoNeededChip: {
    backgroundColor: '#FFF7ED',
    color: '#9A3412',
    border: '1px solid #FED7AA',
    fontWeight: 600,
    height: 'auto',
    maxWidth: '100%',
    alignItems: 'flex-start',
    '& .MuiChip-label': {
      whiteSpace: 'normal',
      lineHeight: 1.35,
      paddingTop: 4,
      paddingBottom: 4
    }
  },
  disabledDropdown: {
    opacity: '0.5'
  }
});
// FIXME: ADD INTERFACE FOR THE PROPS
const AppointmentCardDetails: React.FC<any> = props => {
  const {
    id,
    sendRemindersFlag,
    appointmentObject,
    updateAppointmentArray,
    selectAppointmentToSendReminder,
    check,
    isPatientNameALink = false,
    showLocation = false,
    location = '',
    groupDetails,
    onNavigateFromDetails,
    displayMode = 'default',
    onCollapse
  } = props;

  const {t} = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const patientDetailsDrawer = useSelector(
    (state: any) => state.patientDetailsDrawer
  );
  const clinicsList = useSelector((state: any) => state.clinics.list);
  const patientFormsMapping = patientForms.map(item => {
    item.name = t(item.name);
    return item;
  });

  // vaccineStatus
  const vaccineStatusMapping = VaccineStatusMapping.map(item => {
    item.name = t(item.name);
    return item;
  });

  const claimsStatusMapping = ClaimStatusMapping.map(item => {
    item.name = t(item.name);
    return item;
  });

  const achStatusMapping = ACHStatusMapping.map(item => {
    item.name = t(item.name);
    return item;
  });

  const [isVerifyingInsurance, setIsVerifyingInsurance] = useState<boolean>(
    false
  );

  const {userType, userPermissions} = useSelector((state: State) => state.auth);

  const doesUserHaveEligibilityPermission = Permission.hasEligibilityVerificationPermissions(
    userPermissions,
    AppPermissions.ELIGIBILITY_VERIFICATION.LIST,
    appointmentObject?.clinic_group_id
  );

  const appointmentFeedbackOptions = [
    {
      name: t(APPOINTMENT_PATIENT_FEEDBACK['REQUEST_REVIEW'].name),
      id: APPOINTMENT_PATIENT_FEEDBACK['REQUEST_REVIEW'].id,
      permission: AppPermissions.APPOINTMENT.GOOD_VISIT
    },
    {
      name: t(APPOINTMENT_PATIENT_FEEDBACK['PATIENT_REVIEW'].name),
      id: APPOINTMENT_PATIENT_FEEDBACK['PATIENT_REVIEW'].id,
      permission: AppPermissions.APPOINTMENT.GATHER_FEEDBACK
    }
  ].filter(item =>
    Permission.hasAppointmentPermissions(
      userPermissions,
      item.permission,
      appointmentObject?.clinic_group_id
    )
  );

  const getAppointmentFeedbackLabel = (appointmentFeedback: string) => {
    const feedbackItem = appointmentFeedbackOptions.find(
      it => it.id === appointmentFeedback
    );
    if (feedbackItem) {
      return feedbackItem.name;
    }
    return '';
  };

  const isUserInsuranceRolePermissionExists =
    userType === USER.ADMIN ||
    Permission.hasEligibilityVerificationPermissions(
      userPermissions,
      AppPermissions.ELIGIBILITY_VERIFICATION?.EDIT,
      appointmentObject?.clinic_group_id
    );

  const eligibilityStatusMapping = EligibilityStatusMapping.map(item => {
    item.name = t(item.name);
    return item;
  });

  const verificationStatusMapping = VerificationStatusMapping.map(item => {
    item.name = t(item.name);
    return item;
  });

  const [guarantorValues, setGuarantorValues] = useState<{
    guarantorDrawerOpen: boolean;
    guarantorId: number | string;
    guarantorName: string;
  }>({
    guarantorDrawerOpen: false,
    guarantorId: '',
    guarantorName: ''
  });

  const [
    showManualVerificationDialog,
    setShowManualVerificationDialog
  ] = useState(false);

  const [viewPDF, setViewPDF] = useState<{open: boolean; loading: boolean}>({
    open: false,
    loading: false
  });

  const [
    isVerificationLogDialogOpen,
    setIsVerificationLogDialogOpen
  ] = useState(false);

  const closeVerificationLogDialog = () => {
    setIsVerificationLogDialogOpen(false);
  };

  const openVerificationLogDialog = () => {
    setIsVerificationLogDialogOpen(true);
  };

  const {enqueueSnackbar} = useSnackbar();

  const [isRefreshingAppointment, setIsRefreshingAppointment] = useState(false);
  const [isPostingToEmr, setIsPostingToEmr] = useState(false);
  const [isDetailsExpanded, setIsDetailsExpanded] = useState(false);
  const [postToEmrDialog, setPostToEmrDialog] = useState({
    open: false,
    encounterNumber: ''
  });

  const isRmdAppointment = useMemo(() => {
    const source = appointmentObject?.appointment_source;
    if (
      source &&
      (RMD_APPOINTMENT_SOURCES.includes(source) ||
        source === AppointmentSource.EMR_INTEGRATION)
    ) {
      return true;
    }
    return RMD_APPOINTMENT_STATUSES.includes(appointmentObject?.status);
  }, [appointmentObject?.appointment_source, appointmentObject?.status]);

  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [cancelReason, setCancelReason] = useState('');
  const [cancellingAppointment, setCancellingAppointment] = useState(false);

  const isPatientEmrSyncBlocked = useMemo(() => {
    if (!isRmdAppointment || !appointmentObject?.patient) {
      return false;
    }
    return isPatientEmrSyncPending(appointmentObject.patient);
  }, [isRmdAppointment, appointmentObject?.patient]);

  const guarantorEmrRow = useMemo(
    () => ({
      guarantor_id:
        appointmentObject?.patient?.guarantor?.id ??
        appointmentObject?.patient?.guarantor_id,
      guarantor_posted_to_emr:
        appointmentObject?.patient?.guarantor?.posted_to_emr,
      guarantor_updated_in_emr:
        appointmentObject?.patient?.guarantor?.updated_in_emr,
      guarantor_updated_in_emr_by:
        appointmentObject?.patient?.guarantor?.updated_in_emr_by,
      guarantor_updated_in_emr_at:
        appointmentObject?.patient?.guarantor?.updated_in_emr_at,
      guarantor_record_status:
        appointmentObject?.patient?.guarantor?.record_status,
      guarantor_modified_at: appointmentObject?.patient?.guarantor?.modified_at,
      guarantor_posted_at: appointmentObject?.patient?.guarantor?.posted_at
    }),
    [appointmentObject?.patient]
  );

  const renderPostedByName = () => {
    const postedByUser = appointmentObject?.posted_by_user;
    if (postedByUser) {
      return (
        HelperUtils.commaSeparatedFullName(
          postedByUser.first_name,
          postedByUser.last_name
        ) || 'Inbound EMR Sync'
      );
    }

    return appointmentObject?.posted_to_emr
      ? 'Inbound EMR Sync'
      : t('COMMON.NONE_VALUE');
  };

  const renderPostedOnDate = () => {
    if (appointmentObject?.posted_at) {
      return HelperUtils.formatDisplayDateTime(appointmentObject.posted_at);
    }

    return t('COMMON.NONE_VALUE');
  };

  const {groupId} = useSelector((state: any) => state.auth);
  const selectedClinicId = useSelector(
    (state: any) => state.clinics.selectedClinicId || []
  );

  const TERMINAL_APPOINTMENT_STATUSES = [
    AppointmentStatus.CANCELLED_PCL,
    AppointmentStatus.CANCELLED_VOICE_ASSISTANT,
    AppointmentStatus.COMPLETED_PCL,
    AppointmentStatus.DECLINED,
    'cancelled'
  ];

  const canCancelAppointment = useMemo(() => {
    if (!appointmentObject?.id) {
      return false;
    }
    if (TERMINAL_APPOINTMENT_STATUSES.includes(appointmentObject?.status)) {
      return false;
    }
    return Permission.hasAppointmentPermissions(
      userPermissions,
      AppPermissions.APPOINTMENT.EDIT,
      groupId || appointmentObject?.clinic_group_id
    );
  }, [
    appointmentObject?.clinic_group_id,
    appointmentObject?.id,
    appointmentObject?.status,
    groupId,
    userPermissions
  ]);

  const closeCancelDialog = (): void => {
    if (cancellingAppointment) {
      return;
    }
    setCancelDialogOpen(false);
    setCancelReason('');
  };

  const handleCancelAppointment = async (): Promise<void> => {
    if (!appointmentObject?.id || cancellingAppointment) {
      return;
    }
    const sanitizedReason = cancelReason.trim();
    if (!sanitizedReason) {
      enqueueSnackbar(
        t('APPOINTMENTS.CANCEL_APPOINTMENT_REASON_REQUIRED'),
        SnackBarConfig('e')
      );
      return;
    }
    setCancellingAppointment(true);
    try {
      const deletedAt = new Date().toISOString();
      const response = await updateAppointment(
        appointmentObject.clinic_group_id || groupId,
        appointmentObject.clinic_id,
        appointmentObject.id,
        {
          status: AppointmentStatus.CANCELLED_PCL,
          deleted: true,
          deleted_at: deletedAt,
          update_or_cancel_appt_note: sanitizedReason
        }
      );
      enqueueSnackbar(
        response?.message || t('APPOINTMENTS.CANCEL_APPOINTMENT_SUCCESS'),
        SnackBarConfig('s')
      );
      updateAppointmentArray({
        ...appointmentObject,
        status: AppointmentStatus.CANCELLED_PCL,
        deleted: true,
        deleted_at: deletedAt,
        update_or_cancel_appt_note: sanitizedReason
      });
      setCancelDialogOpen(false);
      setCancelReason('');
    } catch (error: any) {
      enqueueSnackbar(formatApiMessage(error), SnackBarConfig('e'));
    } finally {
      setCancellingAppointment(false);
    }
  };

  // Eligibility verification is enabled at group level and insurance provider is set for the practice
  const isEligibilityVerificationEnabled = useMemo(() => {
    const eligibilityEnabled =
      groupDetails[AppPermissions.MENU_PERMISSIONS.ELIGIBILITY_VERIFICATION];
    if (!eligibilityEnabled) return false;
    const hasClinicListBeenUpdated = clinicsList.some(
      (cl: any) => cl.org_group_id === groupDetails?.id
    );
    if (!hasClinicListBeenUpdated) {
      return false;
    }
    if (Array.isArray(clinicsList)) {
      const clinicDetails = clinicsList.find(
        (cl: any) => cl?.id === selectedClinicId?.[0]
      );
      return !!clinicDetails?.insurance_config?.insurance_provider;
    }
    return false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupDetails, clinicsList, selectedClinicId?.[0]]);

  const [consentFormResponse, setConsentFormResponse] = useState(null);

  const [consentFormReview, setConsentFormReview] = useState<boolean>(false);

  const [remindAgainBoolean, setRemindAgainBoolean] = useState<boolean>(false);

  const [completeVaccineDialog, setCompleteVaccineDialog] = useState<{
    open: boolean;
    promptDose: boolean;
    promptAddress: boolean;
    dose: 1 | 2 | null;
    address_line_1: string;
    city: string;
    state: string;
    zip_code: string;
  }>({
    open: false,
    promptDose: false,
    promptAddress: false,
    dose: null,
    address_line_1: '',
    city: '',
    state: '',
    zip_code: ''
  });

  // Vaccine Status API updation
  const updateVaccineStatus = async (object: any): Promise<void> => {
    setIsRefreshingAppointment(true);
    try {
      const payload: {
        status: any;
        vaccine_dose_number?: 1 | 2;
      } = {
        status: object?.status
      };
      if (
        object?.vaccine_dose_number === 1 ||
        object?.vaccine_dose_number === 2
      ) {
        payload.vaccine_dose_number = object.vaccine_dose_number;
      }
      const response = await updateVaccineStatusAppointment(
        groupId,
        selectedClinicId?.[0],
        object?.id,
        payload
      );
      if (response) {
        enqueueSnackbar(response.message, SnackBarConfig('s'));
        if (response.is_claim_created) {
          enqueueSnackbar(
            t('CLAIMS_TICKETS.CLAIM_CREATED_SUCCESS'),
            SnackBarConfig('s')
          );
        }
        const updatedAppointmentRes = await getAppointmentById(
          object?.clinic_group_id,
          object?.clinic_id,
          object?.id
        );
        const updatedAppointmentObj = updatedAppointmentRes?.data;
        if (updatedAppointmentObj) {
          updateAppointmentArray(updatedAppointmentObj);
        }
      }
    } catch (error: any) {
      enqueueSnackbar(formatApiMessage(error), SnackBarConfig('e'));
    } finally {
      setIsRefreshingAppointment(false);
    }
  };

  const updateSelectedAppointment = async (
    object: any,
    key?: string
  ): Promise<void> => {
    try {
      setIsRefreshingAppointment(true);
      const {
        eligibility_status,
        patient_forms,
        verification_status,
        is_manually_verified,
        ach_status,
        claim_status,
        review_type
      } = object;
      let response;
      // If the key is 'review_type' and the review_type is 'patient_review', call the updateGatherFeedBackAppointment API
      if (key === 'review_type') {
        const payload = {
          review_type
        };
        response = await updateGatherFeedBackAppointment(
          appointmentObject?.clinic_group_id,
          appointmentObject?.clinic_id,
          appointmentObject?.id,
          payload
        );
      } else {
        // for other action dropdowns call the Appointments API's
        const payload = {
          eligibility_status,
          patient_forms,
          verification_status,
          is_manually_verified,
          ach_status,
          claim_status
        };

        response = await updateAppointment(
          appointmentObject?.clinic_group_id,
          appointmentObject?.clinic_id,
          appointmentObject?.id,
          payload
        );
      }
      if (response) {
        enqueueSnackbar(response.message, SnackBarConfig('s'));
        const updatedAppointmentRes = await getAppointmentById(
          appointmentObject?.clinic_group_id,
          appointmentObject?.clinic_id,
          appointmentObject?.id
        );
        const updatedAppointmentObj = updatedAppointmentRes?.data;
        if (updatedAppointmentObj) {
          updateAppointmentArray(updatedAppointmentObj);
        }
      }
    } catch (error: any) {
      enqueueSnackbar(formatApiMessage(error), SnackBarConfig('e'));
      // throw error;
    } finally {
      setIsRefreshingAppointment(false);
    }
  };

  const openPostToEmrDialog = (): void => {
    if (
      appointmentObject?.posted_to_emr ||
      isPostingToEmr ||
      !appointmentObject?.clinic_id ||
      !appointmentObject?.id
    ) {
      return;
    }

    if (isPatientEmrSyncBlocked) {
      enqueueSnackbar(
        t('APPOINTMENTS.PATIENT_NOT_SYNCED_TO_EMR_BLOCK_POST'),
        SnackBarConfig('w')
      );
      return;
    }

    setPostToEmrDialog({
      open: true,
      encounterNumber: appointmentObject?.encounter_number || ''
    });
  };

  const closePostToEmrDialog = (): void => {
    setPostToEmrDialog({
      open: false,
      encounterNumber: ''
    });
  };

  const handleMarkPostedToEmr = async (): Promise<void> => {
    const encounterNumber = postToEmrDialog.encounterNumber.trim();

    if (
      appointmentObject?.posted_to_emr ||
      isPostingToEmr ||
      !appointmentObject?.clinic_id ||
      !appointmentObject?.id
    ) {
      return;
    }

    if (isPatientEmrSyncBlocked) {
      enqueueSnackbar(
        t('APPOINTMENTS.PATIENT_NOT_SYNCED_TO_EMR_BLOCK_POST'),
        SnackBarConfig('w')
      );
      return;
    }

    try {
      setIsPostingToEmr(true);
      const response = await markAppointmentPostedToEmr(
        appointmentObject.clinic_group_id || groupId,
        appointmentObject.clinic_id,
        appointmentObject.id,
        {encounter_number: encounterNumber || undefined}
      );
      if (response) {
        enqueueSnackbar(
          response.message || t('APPOINTMENTS.POSTING_STATUS_UPDATED'),
          SnackBarConfig('s')
        );
        await getAppointment({
          clinicGroupId: appointmentObject.clinic_group_id || groupId,
          clinicId: appointmentObject.clinic_id,
          appointmentId: appointmentObject.id
        });
        closePostToEmrDialog();
      }
    } catch (error: any) {
      enqueueSnackbar(formatApiMessage(error), SnackBarConfig('e'));
    } finally {
      setIsPostingToEmr(false);
    }
  };

  const getAppointment = React.useCallback(
    async (data: {
      clinicGroupId: number | string;
      clinicId: number | string;
      appointmentId: number | string;
    }) => {
      setIsRefreshingAppointment(true);
      try {
        const updatedAppointmentRes = await getAppointmentById(
          data.clinicGroupId,
          data.clinicId,
          data.appointmentId
        );
        const updatedAppointmentObj = updatedAppointmentRes?.data;
        if (updatedAppointmentObj) {
          updateAppointmentArray(updatedAppointmentObj);
        }
      } catch (error: any) {
        enqueueSnackbar(formatApiMessage(error), SnackBarConfig('e'));
      } finally {
        setIsRefreshingAppointment(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [updateAppointmentArray]
  );

  React.useEffect(() => {
    // if there is an update available and no state passed to route
    const subscription = CommunicationService.getEvent().subscribe(event => {
      if (event.action === 'REFRESH_APPOINTMENT') {
        if (event.data && event.data.appointmentId === appointmentObject?.id) {
          getAppointment({
            clinicGroupId: event.data.clinicGroupId,
            clinicId: event.data.clinicId,
            appointmentId: event.data.appointmentId
          });
        }
      }
    });
    return () => {
      subscription.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appointmentObject?.id, getAppointment]);

  const confirmCompleteVaccine = async (): Promise<void> => {
    const patient = appointmentObject?.patient;
    const {
      promptDose,
      promptAddress,
      dose,
      address_line_1,
      city,
      state,
      zip_code
    } = completeVaccineDialog;
    const doseToSend = promptDose
      ? dose
      : appointmentObject?.vaccine_dose_number;
    if (promptDose && doseToSend !== 1 && doseToSend !== 2) {
      enqueueSnackbar(
        t('APPOINTMENTS.SELECT_VACCINE_DOSE_TO_COMPLETE'),
        SnackBarConfig('e')
      );
      return;
    }
    const addrNeeded = promptAddress && patientNeedsShippingAddress(patient);
    if (addrNeeded) {
      const missing =
        !address_line_1?.trim() ||
        !city?.trim() ||
        !state?.trim() ||
        !zip_code?.trim();
      if (missing) {
        enqueueSnackbar(
          'Please enter street address, city, state, and ZIP.',
          SnackBarConfig('e')
        );
        return;
      }
    }
    setIsRefreshingAppointment(true);
    try {
      if (addrNeeded && patient?.id) {
        const detRes = await getSpecificPatientDetails(
          appointmentObject.clinic_group_id,
          appointmentObject.clinic_id,
          patient.id
        );
        const flat = detRes?.data;
        if (!flat) {
          throw new Error(t('PATIENTS.GET_PATIENT_DETAILS_ERROR'));
        }
        await updatePatient(
          appointmentObject.clinic_group_id,
          mapFlatPatientDetailToEditPayload(
            flat,
            appointmentObject.clinic_id,
            {
              address_line_1: address_line_1.trim(),
              city: city.trim(),
              state: state.trim(),
              zip_code: zip_code.trim()
            },
            patient
          )
        );
      }
      const response = await updateVaccineStatusAppointment(
        groupId,
        selectedClinicId?.[0],
        appointmentObject?.id,
        {
          status: AppointmentStatus.COMPLETED_PCL,
          vaccine_dose_number: doseToSend as 1 | 2
        }
      );
      if (response) {
        enqueueSnackbar(response.message, SnackBarConfig('s'));
        if (response.is_claim_created) {
          enqueueSnackbar(
            t('CLAIMS_TICKETS.CLAIM_CREATED_SUCCESS'),
            SnackBarConfig('s')
          );
        }
        const updatedAppointmentRes = await getAppointmentById(
          appointmentObject?.clinic_group_id,
          appointmentObject?.clinic_id,
          appointmentObject?.id
        );
        const updatedAppointmentObj = updatedAppointmentRes?.data;
        if (updatedAppointmentObj) {
          updateAppointmentArray(updatedAppointmentObj);
        }
      }
      setCompleteVaccineDialog(d => ({...d, open: false}));
    } catch (error: any) {
      enqueueSnackbar(formatApiMessage(error), SnackBarConfig('e'));
    } finally {
      setIsRefreshingAppointment(false);
    }
  };

  const handleDropDown = (key: string | any, item: any) => {
    const object: any = {...appointmentObject};
    object[key] = item?.id;
    if (key === 'status') {
      if (item?.id === AppointmentStatus.COMPLETED_PCL) {
        const p = appointmentObject?.patient;
        const addrNeeded = patientNeedsShippingAddress(p);
        const doseMissing =
          appointmentObject?.vaccine_dose_number !== 1 &&
          appointmentObject?.vaccine_dose_number !== 2;
        if (!addrNeeded && !doseMissing) {
          updateVaccineStatus(object);
          return;
        }
        setCompleteVaccineDialog({
          open: true,
          promptDose: doseMissing,
          promptAddress: addrNeeded,
          dose: doseMissing
            ? null
            : (appointmentObject?.vaccine_dose_number as 1 | 2),
          address_line_1: p?.address_line_1 ?? '',
          city: p?.city ?? '',
          state: p?.state ?? '',
          zip_code: p?.zip_code ?? ''
        });
        return;
      }
      updateVaccineStatus(object);
    } else {
      updateSelectedAppointment(object, key);
    }
  };

  const getVerificationStatusName = () => {
    let statusIDToDisplay = '';
    if (
      appointmentObject?.verification_status ===
      VerificationStatusObj.NOT_VERIFIED
    ) {
      statusIDToDisplay = appointmentObject?.verification_status;
    }
    if (
      appointmentObject?.verification_status === VerificationStatusObj.VERIFIED
    ) {
      if (appointmentObject?.is_manually_verified === false) {
        statusIDToDisplay = VerificationStatusObj.AUTOMATIC_VERIFIED;
      } else {
        statusIDToDisplay = VerificationStatusObj.MANUALLY_VERIFIED;
      }
    }
    const verificationStatusToDisplay = verificationStatusMapping.find(
      i => i.id === statusIDToDisplay
    );
    if (verificationStatusToDisplay) {
      return verificationStatusToDisplay.name;
    }
    return '';
  };
  const clinicList = useSelector((state: any) => state.clinics.list || []);

  const getClinicTimeZone = (_clinicId: string): string => {
    let timezone = '';
    if (clinicList && Array.isArray(clinicList)) {
      const clinic = clinicList.find(c => c.id === _clinicId);
      if (clinic) {
        timezone = clinic?.zone;
      }
    }
    return timezone;
  };

  // FIXME: USE CUSTOM DROPDOWN COMPONENT
  const renderDropDown = (
    list: any,
    value: any,
    onClickAction: any,
    header: any,
    activeValue: any,
    placeholder?: any,
    options?: {
      showClear?: boolean;
      onClear?: () => void;
    },
    disabled?: boolean
  ): React.ReactElement => {
    const dropdownClass: any = disabled
      ? `${classes.clinicsDropDownWidth} ${classes.disabledDropdown}`
      : classes.clinicsDropDownWidth;
    return (
      <div className={dropdownClass}>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          value={value}
          variant="outlined"
          placeholder={placeholder || ''}
          fullWidth={true}
          input={<CustomSelectField />}
          IconComponent={KeyboardArrowDownIcon}
          className="selectView select-clinic"
          disabled={disabled}>
          <div className={classes.root}>
            <div className={classes.ClinicFilterHeader}>
              <Typography className={classes.clinicText}>{header}</Typography>
              {options?.showClear && (
                <Button
                  className={classes.clearAll}
                  onClick={() => {
                    if (options.onClear) {
                      options.onClear();
                    }
                  }}>
                  {t('COMMON.CLEAR')}
                </Button>
              )}
            </div>
            <Divider />
            <div className={classes.ClinicMenu}>
              {list?.map((item: any) => (
                <MenuItem
                  key={item.id}
                  value={item.name}
                  onClick={(): void => {
                    onClickAction(item);
                  }}>
                  <ListItemText
                    className={[classes.primary].join(' ')}
                    primary={item.name}
                  />
                  <Radio checked={activeValue === item?.id ? true : false} />
                </MenuItem>
              ))}
            </div>
          </div>
        </Select>
      </div>
    );
  };

  /**
   * FUNCTION TO RETURN APPOINTMENT DURATION
   * @param durationValue
   * @returns string
   */
  const renderAppointmentDuration = (durationValue: any): string => {
    if (durationValue) {
      return `${durationValue} ${t('APPOINTMENTS.APPOINTMENT_MINUTES_TEXT')}`;
    }
    return '-';
  };

  const mapEligibilityStatus = () => {
    const [eligibilityStatus] = eligibilityStatusMapping.filter(
      item => item.id == appointmentObject.eligibility_status
    );
    if (eligibilityStatus) {
      return eligibilityStatus;
    } else {
      return {
        id: appointmentObject.eligibility_status,
        color: '',
        backgroundColor: '',
        name: appointmentObject.eligibility_status
      };
    }
  };

  const verifyingInsurance = (value: boolean) => {
    setIsVerifyingInsurance(value);
  };

  // Permission check added for the dropdown to display the detials
  const hasPatientReviewPermission = React.useMemo(() => {
    // USER DOESN'T HAVE FEEDBACK PERMISSION
    if (
      !Permission.hasFeedBackPermissions(
        userPermissions,
        AppPermissions.PATIENT_REVIEW.LIST,
        groupId
      )
    ) {
      return false;
    }
    // ** checking the clinic is belonging to that particular group or not */
    const hasClinicListBeenUpdated = clinicsList.some(
      (cl: any) => cl.org_group_id === groupId
    );
    if (!hasClinicListBeenUpdated) {
      return false;
    }
    if (Array.isArray(clinicsList)) {
      const clinicDetails = clinicsList.find(
        (cl: any) => cl?.id === selectedClinicId?.[0]
      );
      return clinicDetails?.is_patient_review_enabled === true;
    }
    return false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userPermissions, groupId, clinicsList, selectedClinicId?.[0]]);

  const closeGuarantorDrawer = (): void => {
    setGuarantorValues({
      ...guarantorValues,
      guarantorDrawerOpen: false,
      guarantorId: '',
      guarantorName: ''
    });
  };

  const shouldShowGuarantorInfoNeededChip =
    Boolean(appointmentObject?.patient?.guarantor?.form_sent) &&
    appointmentObject?.patient?.guarantor?.is_guarantor_info_submitted ===
      false;

  // declared here to override the colors of appointment card
  const getConsentFormAttention = () => {
    const value = JSON.parse(appointmentObject?.consent_meta);
    if (value?.status === CONSENT_METADATA_STATUS_MAPPER.NEEDS_ATTENTION) {
      return `${t('APPOINTMENTS.NEEDS_ATTENTION')}`;
    }
    return '';
  };
  let appointmentCardStyle: React.CSSProperties = {
    borderLeft: `0.5rem solid ${
      EligibilityStatusMappingObj[appointmentObject.eligibility_status]
        ?.borderColor ?? APP.COLOR.ELIGIBILITY_STATUS.NOT_VERIFIED_BORDER_COLOR
    }`,
    backgroundColor:
      EligibilityStatusMappingObj[appointmentObject.eligibility_status]
        ?.backgroundColor ??
      APP.COLOR.ELIGIBILITY_STATUS.NOT_VERIFIED_BACKGROUND_COLOR
  };
  // ** Overriding the eligiliblity status styles if the appointment is having needs attention as status //
  if (appointmentObject) {
    const attentionValue = getConsentFormAttention();
    if (attentionValue != '') {
      appointmentCardStyle = {
        borderLeft: `0.5rem solid ${APP.COLOR.ELIGIBILITY_STATUS.NOT_APPLICABLE_BORDER_COLOR}`,
        backgroundColor:
          APP.COLOR.ELIGIBILITY_STATUS.NOT_APPLICABLE_BACKGROUND_COLOR
      };
    }
  }
  const hasCoverages =
    Array.isArray(appointmentObject?.coverages) &&
    appointmentObject.coverages.length > 0
      ? true
      : false;

  const openPatientDrawerTab = (tab: string) => {
    if (patientDetailsDrawer?.open) {
      dispatch(_setActiveTab(tab));
    } else {
      dispatch(
        _patientDrawerDetails(
          appointmentObject?.clinic_group_id,
          appointmentObject?.clinic_id,
          appointmentObject?.patient_id,
          tab
        )
      );
    }
    onNavigateFromDetails?.({type: 'patient'});
  };

  const navigateToPatientDetailsDrawer = () => {
    openPatientDrawerTab(PatientsTabKeys.PATIENT_DETAILS);
  };

  const navigateToGuarantorDrawer = (): void => {
    if (!appointmentObject?.patient_id) {
      return;
    }

    const guarantorName = HelperUtils.commaSeparatedFullName(
      appointmentObject?.patient?.guarantor?.first_name,
      appointmentObject?.patient?.guarantor?.last_name,
      appointmentObject?.patient?.guarantor?.middle_name
    );

    if (onNavigateFromDetails) {
      onNavigateFromDetails({
        type: 'guarantor',
        guarantorId: appointmentObject?.patient?.guarantor_id,
        guarantorName,
        clinicId: appointmentObject?.clinic_id
      });
      return;
    }

    setGuarantorValues({
      ...guarantorValues,
      guarantorDrawerOpen: true,
      guarantorId: appointmentObject?.patient?.guarantor_id,
      guarantorName
    });
  };

  const renderPatientEmrStatus = (): React.ReactElement => {
    const patient = appointmentObject?.patient;
    if (!patient) {
      return <span>—</span>;
    }

    const awaitingPost = isPatientAwaitingEmrPost(patient);
    const canUpdate = canMarkPatientUpdatedInEmr(patient);
    const linkStyle = {margin: 0, marginTop: 4, cursor: 'pointer'};

    if (awaitingPost) {
      return (
        <p
          className={`${classes.LinkStyle} ${classes.wrapLink}`}
          onClick={() => navigateToPatientDetailsDrawer()}
          style={linkStyle}>
          {t('PATIENTS.EMR_STATUS_NOT_POSTED')}
        </p>
      );
    }

    if (canUpdate) {
      return (
        <p
          className={`${classes.LinkStyle} ${classes.wrapLink}`}
          onClick={() => navigateToPatientDetailsDrawer()}
          style={linkStyle}>
          {t('PATIENTS.EMR_STATUS_NOT_UPDATED')}
        </p>
      );
    }

    if (showsPatientEmrSyncedChip(patient)) {
      return (
        <span style={{marginTop: 4, display: 'block'}}>
          <EmrSyncStatusChip hasIntegration syncStatus="synced" />
        </span>
      );
    }

    return <span>—</span>;
  };

  const renderGuarantorEmrStatus = (): React.ReactElement | null => {
    if (!guarantorEmrRow?.guarantor_id) {
      return null;
    }

    const awaitingPost = isGuarantorAwaitingEmrPost(guarantorEmrRow);
    const canUpdate = canMarkGuarantorUpdatedInEmr(guarantorEmrRow);
    const linkStyle = {marginTop: 4, cursor: 'pointer', marginBottom: 0};

    if (awaitingPost) {
      return (
        <p
          className={`${classes.LinkStyle} ${classes.wrapLink}`}
          onClick={navigateToGuarantorDrawer}
          style={linkStyle}>
          {t('PATIENTS.EMR_STATUS_GUARANTOR_NOT_POSTED')}
        </p>
      );
    }

    if (canUpdate) {
      return (
        <p
          className={`${classes.LinkStyle} ${classes.wrapLink}`}
          onClick={navigateToGuarantorDrawer}
          style={linkStyle}>
          {t('PATIENTS.EMR_STATUS_GUARANTOR_NOT_UPDATED')}
        </p>
      );
    }

    if (showsGuarantorEmrSyncedChip(guarantorEmrRow)) {
      return (
        <span style={{marginTop: 4, display: 'block'}}>
          <EmrSyncStatusChip hasIntegration syncStatus="synced" />
        </span>
      );
    }

    return null;
  };

  const navigateToPatientEligibilityDrawer = () => {
    dispatch(
      _setEligibilityVerificationAppointmentPatientDrawer(appointmentObject)
    );
    const tab =
      isEligibilityVerificationEnabled && isUserInsuranceRolePermissionExists
        ? PatientsTabKeys.ELIGIBILITY_VERIFICATION
        : PatientsTabKeys.PATIENT_DETAILS;
    openPatientDrawerTab(tab);
  };

  /**
     1. Eligibility verification should be enabled at group
     2. Logged in user should have insurance role permission
     3. Verification status should be verified
     4. Eligibility status should not be No Information
     */
  const canEnableViewInsuranceDetails =
    isEligibilityVerificationEnabled &&
    isUserInsuranceRolePermissionExists &&
    appointmentObject.verification_status === VerificationStatusObj.VERIFIED &&
    (appointmentObject?.coverages?.length > 0 || appointmentObject?.plan);

  /**
     1. Eligibility verification should be enabled at group
     2. Logged in user should have insurance role permission
     3. Verification status either verified or verified and eligibility status is no information
     4. Eligibility status should not be No Information
     */
  const canEnableAddInsuranceInformation =
    appointmentObject?.patient_id &&
    isEligibilityVerificationEnabled &&
    isUserInsuranceRolePermissionExists &&
    appointmentObject?.is_eligibility_verification_processing === false &&
    !isVerifyingInsurance &&
    (appointmentObject.verification_status ===
      VerificationStatusObj.NOT_VERIFIED ||
      (appointmentObject.verification_status ===
        VerificationStatusObj.VERIFIED &&
        !appointmentObject.is_manually_verified &&
        appointmentObject.eligibility_status ===
          EligibilityStatusObj.NO_INFORMATION));

  // view vaccine record details API Integration
  const viewVaccineDetails = async (): Promise<void> => {
    try {
      setViewPDF({open: true, loading: true});
      const response = await getVaccineRecordDetails(
        groupId,
        selectedClinicId?.[0],
        appointmentObject?.id
      );
      if (response) {
        setConsentFormResponse(response);
        setViewPDF({open: true, loading: false});
      }
    } catch (error: any) {
      enqueueSnackbar(
        (error && error?.message) || (error && error?.data[0]?.message),
        SnackBarConfig('e')
      );
    } finally {
      setViewPDF({open: true, loading: false});
    }
  };
  // consent form API integration
  const fetchVaccineConsentForm = async (appointmentId: number) => {
    try {
      setViewPDF({open: true, loading: true});
      const response = await getVaccineFileDataConsentForm(
        groupId,
        selectedClinicId?.[0],
        appointmentId
      );
      if (response) {
        setConsentFormResponse(response);
        setViewPDF({open: true, loading: false});
      }
    } catch (err: any) {
      // enqueueSnackbar(err?.message, SnackBarConfig('e'));
      setConsentFormResponse(null);
    } finally {
      setViewPDF({open: true, loading: false});
    }
  };

  const OnClickViewConsentFormDialog = (appointmentParamId: number) => {
    fetchVaccineConsentForm(appointmentParamId);
  };

  const onClickReviewConsentFormDialog = () => {
    setConsentFormReview(true);
  };

  const renderViewConsentFormDialog = () => {
    return (
      // <PdfViewer file={consentFormResponse} />
      <ViewConsentFormDialog
        // title={ }
        isLoading={viewPDF.loading}
        open={viewPDF.open}
        onClose={() => {
          setViewPDF({open: false, loading: false});
          setConsentFormResponse(null);
        }}
        file={consentFormResponse}
        description={
          consentFormResponse ? null : t('APPOINTMENTS.NO_CONSENT_FORM')
        }
      />
    );
  };

  // rendering the ConsentFormReview
  const renderReviewConsentFormDialog = () => {
    return (
      <ReviewConsentFormDialog
        open={consentFormReview}
        appointmentId={appointmentObject?.id}
        onClose={res => {
          if (res === 'confirm') {
            // DISPATCH TO REFRESH THE APPOINTMENT
            CommunicationService.sendEvent({
              action: 'REFRESH_APPOINTMENT',
              data: {
                clinicGroupId: appointmentObject?.clinic_group_id,
                clinicId: appointmentObject?.clinic_id,
                appointmentId: appointmentObject?.id
              }
            });
            setConsentFormReview(false);
          } else {
            setConsentFormReview(false);
          }
        }}
      />
    );
  };

  const handleSendFeedBackRemindAgain = async (appointment: any) => {
    if (appointment) {
      setRemindAgainBoolean(true);
      try {
        await remindAgain(groupId, selectedClinicId?.[0], appointment?.id);
        setRemindAgainBoolean(false);
      } catch (error: any) {
        enqueueSnackbar(
          (error && error?.message) ||
            (error && error?.data[0]?.message) ||
            t('APPOINTMENTS.APPOINTMENTS_ERROR'),
          SnackBarConfig('e')
        );
      } finally {
        setRemindAgainBoolean(false);
      }
    }
  };
  const renderRemindAgainLink = (appointment: any) => {
    return (
      <p className={classes.LinkStyle}>
        {remindAgainBoolean ? (
          <Loader />
        ) : (
          <span onClick={() => handleSendFeedBackRemindAgain(appointment)}>
            {t('APPOINTMENTS.REMIND_AGAIN')}
          </span>
        )}
      </p>
    );
  };

  const renderFeedBackSelectedValue = () => {
    return (
      <div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.2rem'
          }}>
          {getAppointmentFeedbackLabel(appointmentObject?.review_type)}
          {appointmentObject?.review_status === 'sent' ? (
            <Tooltip title={t('Text is sent').toString()}>
              <CheckIcon
                style={{color: APP.STATUS.SUCCESS}}
                fontSize={'small'}
              />
            </Tooltip>
          ) : (
            ''
          )}
          {appointmentObject?.review_status === 'processing' ? (
            <Tooltip title={t('Processing').toString()}>
              <span>
                <ReminderProcessIcon style={{color: 'orange', width: '18px'}} />
              </span>
            </Tooltip>
          ) : (
            ''
          )}
          {appointmentObject?.review_status === 'failed' ? (
            <Tooltip title={t('SMS_STATUSES.FAILED') ?? ''}>
              <span>
                <ErrorIcon
                  style={{color: APP.STATUS.ERROR}}
                  fontSize={'small'}
                />
              </span>
            </Tooltip>
          ) : (
            ''
          )}
        </div>
        {['sent', 'failed'].includes(appointmentObject?.review_status) ? (
          <div>{renderRemindAgainLink(appointmentObject)}</div>
        ) : (
          ''
        )}
      </div>
    );
  };

  const isInlineDisplay = displayMode === 'inline';
  const showFullDetails = isInlineDisplay || isDetailsExpanded;

  const isInteractiveCardClickTarget = (target: HTMLElement): boolean =>
    Boolean(
      target.closest(
        [
          'button',
          'a',
          'input',
          'select',
          'textarea',
          'label',
          '[role="button"]',
          '.MuiIconButton-root',
          '.MuiCheckbox-root',
          '.MuiFormControlLabel-root',
          '.MuiMenuItem-root',
          '.MuiSelect-root',
          '.appointments-card-detail-wrapper__details-toggle'
        ].join(', ')
      )
    ) || Boolean(target.closest(`.${classes.LinkStyle}`));

  const handleExpandDetails = (event: React.MouseEvent): void => {
    event.stopPropagation();
    if (isInlineDisplay) {
      return;
    }
    setIsDetailsExpanded(true);
  };

  const handleCollapseDetails = (event: React.MouseEvent): void => {
    event.stopPropagation();
    if (isInlineDisplay && onCollapse) {
      onCollapse();
      return;
    }
    setIsDetailsExpanded(false);
  };

  const handleCardClick = (event: React.MouseEvent): void => {
    if (isInlineDisplay || isDetailsExpanded) {
      return;
    }
    if (isInteractiveCardClickTarget(event.target as HTMLElement)) {
      return;
    }
    setIsDetailsExpanded(true);
  };

  const renderDetailsToggle = (): ReactElement | null => {
    const canToggle = !isInlineDisplay || !!onCollapse;
    if (!canToggle) {
      return null;
    }

    const isExpanded = isInlineDisplay || isDetailsExpanded;
    const toggleLabel = isExpanded
      ? t('APPOINTMENTS.COLLAPSE_DETAILS')
      : t('APPOINTMENTS.VIEW_MORE_DETAILS');

    return (
      <div className="appointments-card-detail-wrapper__details-toggle">
        <Tooltip title={toggleLabel}>
          <IconButton
            size="small"
            color="primary"
            onClick={isExpanded ? handleCollapseDetails : handleExpandDetails}
            aria-label={toggleLabel}
            data-test-id={
              isExpanded
                ? 'pcl-appointments-collapseDetails'
                : 'pcl-appointments-viewMoreDetails'
            }>
            {isExpanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Tooltip>
      </div>
    );
  };

  const renderCardBody = (): ReactElement => (
    <>
      {isRefreshingAppointment && (
        <div className={classes.loadingOverlay}>
          <Loader />
        </div>
      )}
      {renderDetailsToggle()}
      <div
        className={classes.subWrapper}
        data-test-id="pcl-appointments-appointmentCardWrapper">
        {sendRemindersFlag && appointmentObject?.id && (
          <Grid container spacing={4}>
            <Grid item xs={12} className={classes.checkBoxGrid}>
              <FormControlLabel
                className={classes.checkboxControl}
                control={
                  <CheckBoxField
                    data-test-id="pcl-appointments-checkbox"
                    checked={check}
                    onChange={() => {
                      selectAppointmentToSendReminder(appointmentObject?.id);
                    }}
                  />
                }
                label={t('APPOINTMENTS.CHECK_INFO')}
              />
            </Grid>
          </Grid>
        )}

        <Grid container spacing={3}>
          {showLocation && (
            <Grid item md={3} lg={2} sm={4} xs={6}>
              <DropDownFieldValue
                label={t('APPOINTMENTS.LOCATION')}
                value={location}
              />
            </Grid>
          )}
          <Grid item md={3} lg={2} sm={4} xs={6}>
            <DropDownFieldValue
              label={t('APPOINTMENTS.APPOINTMENT_DATE_TIME')}
              value={
                appointmentObject?.appointment_at
                  ? appointmentsDateTimeFormat(
                      appointmentObject?.appointment_at,
                      getClinicTimeZone(appointmentObject?.clinic_id)
                    )
                  : '-'
              }
              valueStyles={classes.appointmentTime}
            />
          </Grid>
          <Grid item md={3} lg={2} sm={4} xs={6}>
            <DropDownFieldValue
              label={t('APPOINTMENTS.DURATION')}
              value={renderAppointmentDuration(
                appointmentObject?.duration || ''
              )}
            />
          </Grid>
          <Grid item md={3} lg={2} sm={4} xs={6}>
            <div style={{overflowWrap: 'break-word'}}>
              <DropDownFieldValue
                label={t('APPOINTMENTS.TYPE')}
                value={
                  appointmentObject?.appointment_type?.label
                    ? appointmentObject?.appointment_type?.label
                    : appointmentObject?.type || '-'
                }
              />
            </div>
          </Grid>
          <Grid item md={3} lg={2} sm={4} xs={6}>
            {appointmentObject?.vaccine_id || appointmentObject?.vaccine?.id ? (
              <DropDownFieldValue
                label={t(
                  'APPOINTMENTS_SCHEDULAR_PORTAL.ADMIN_PORTAL.VACCINE_NAME'
                )}
                value={appointmentObject?.vaccine?.proprietary_name || '-'}
              />
            ) : (
              <DropDownFieldValue
                label={t('ADD_PATIENT.PROVIDER_NAME')}
                value={
                  appointmentObject?.provider_name
                    ? appointmentObject.provider_name
                    : appointmentObject?.provider
                    ? appointmentObject.provider?.last_name +
                      ' ' +
                      appointmentObject.provider?.first_name
                    : '-'
                }
              />
            )}
          </Grid>
          <Grid item md={3} lg={2} sm={4} xs={6}>
            {appointmentObject?.patient_id &&
            HelperUtils.checkPatientNameAvailable(
              appointmentObject?.patient || {}
            ) ? (
              <DropDownFieldValue
                label={t('PRODUCT_CHECKOUT.PATIENT_NAME')}
                value={
                  <div>
                    <div>
                      {HelperUtils.commaSeparatedFullName(
                        appointmentObject?.patient?.first_name,
                        appointmentObject?.patient?.last_name,
                        appointmentObject?.patient?.middle_name
                      )}
                    </div>
                    {isRmdAppointment ? renderPatientEmrStatus() : null}
                  </div>
                }
                onClickAction={() => {
                  if (!isPatientNameALink) {
                    return;
                  }
                  navigateToPatientDetailsDrawer();
                }}
                valueStyles={isPatientNameALink ? classes.LinkStyle : ''}
              />
            ) : (
              <DropDownFieldValue
                label={t('PRODUCT_CHECKOUT.PATIENT_NAME')}
                value={t('PRODUCT_CHECKOUT.NEW_PATIENT')}
              />
            )}
          </Grid>
          <Grid item md={3} lg={2} sm={4} xs={6}>
            <DropDownFieldValue
              label={t('PATIENTS.GUARANTOR')}
              value={
                <div>
                  <div>
                    {HelperUtils.commaSeparatedFullName(
                      appointmentObject?.patient?.guarantor?.first_name,
                      appointmentObject?.patient?.guarantor?.last_name,
                      appointmentObject?.patient?.guarantor?.middle_name
                    ) || '-'}
                  </div>
                  {renderGuarantorEmrStatus()}
                </div>
              }
              onClickAction={() => {
                if (appointmentObject?.patient_id) {
                  navigateToGuarantorDrawer();
                }
              }}
              valueStyles={
                appointmentObject?.patient_id ? classes.LinkStyle : ''
              }
            />
          </Grid>

          {showFullDetails && (
            <>
              <Grid item md={3} lg={2} sm={4} xs={6}>
                {appointmentObject?.vaccine_id ? (
                  appointmentObject?.status ===
                  AppointmentStatus.COMPLETED_PCL ? (
                    <DropDownFieldValue
                      label={t(
                        'APPOINTMENTS_SCHEDULAR_PORTAL.ADMIN_PORTAL.VACCINE_STATUS'
                      )}
                      value={
                        <div>
                          <div>
                            {t(
                              'APPOINTMENTS_SCHEDULAR_PORTAL.APPOINTMENTS.COMPLETED'
                            )}
                          </div>
                          <div
                            className={classes.LinkStyle}
                            onClick={() => viewVaccineDetails()}>
                            {t(
                              'APPOINTMENTS_SCHEDULAR_PORTAL.ADMIN_PORTAL.VIEW_VACCINE_RECORD'
                            )}
                          </div>
                        </div>
                      }
                    />
                  ) : (
                    <DropDownFieldValue
                      label={t(
                        'APPOINTMENTS_SCHEDULAR_PORTAL.ADMIN_PORTAL.VACCINE_STATUS'
                      )}
                      dropDown={renderDropDown(
                        vaccineStatusMapping,
                        FormUtils.getFieldName(
                          vaccineStatusMapping,
                          appointmentObject?.status
                        ),
                        (item: any) => {
                          handleDropDown('status', item);
                        },
                        'Vaccine Status', // FIXME: TAKE TEXT FROM TRANSLATION
                        appointmentObject?.status,
                        '', // placeholder is optional
                        {}, // your options, if any
                        appointmentObject?.eligibility_status === 'active'
                          ? false
                          : true // Pass the disabled prop based on eligibility_status
                      )}
                      valueStyles={classes.dropDown}
                    />
                  )
                ) : (
                  <DropDownFieldValue
                    label={t('PATIENTS.STATUS')}
                    value={t(
                      appointmentObject?.status
                        ? t(getAppointmentStatus(appointmentObject.status))
                        : '-'
                    )}
                  />
                )}
              </Grid>

              {appointmentObject?.vaccine_id &&
                appointmentObject?.status !==
                  AppointmentStatus.COMPLETED_PCL && (
                  <Grid item md={12} sm={12} xs={12}>
                    <Typography variant="caption" display="block" gutterBottom>
                      {t('APPOINTMENTS.VACCINE_DOSE')}
                    </Typography>
                    <RadioGroup
                      row
                      value={
                        appointmentObject?.vaccine_dose_number === 1 ||
                        appointmentObject?.vaccine_dose_number === 2
                          ? String(appointmentObject.vaccine_dose_number)
                          : ''
                      }
                      onChange={async e => {
                        const v = parseInt(e.target.value, 10);
                        if (v !== 1 && v !== 2) {
                          return;
                        }
                        try {
                          setIsRefreshingAppointment(true);
                          const response = await updateAppointment(
                            appointmentObject?.clinic_group_id,
                            appointmentObject?.clinic_id,
                            appointmentObject?.id,
                            {vaccine_dose_number: v}
                          );
                          if (response) {
                            enqueueSnackbar(
                              response.message,
                              SnackBarConfig('s')
                            );
                            const updatedAppointmentRes = await getAppointmentById(
                              appointmentObject?.clinic_group_id,
                              appointmentObject?.clinic_id,
                              appointmentObject?.id
                            );
                            const updatedAppointmentObj =
                              updatedAppointmentRes?.data;
                            if (updatedAppointmentObj) {
                              updateAppointmentArray(updatedAppointmentObj);
                            }
                          }
                        } catch (error: any) {
                          enqueueSnackbar(
                            formatApiMessage(error),
                            SnackBarConfig('e')
                          );
                        } finally {
                          setIsRefreshingAppointment(false);
                        }
                      }}>
                      <FormControlLabel
                        value="1"
                        control={<Radio color="primary" />}
                        label={t('APPOINTMENTS.VACCINE_DOSE_FIRST')}
                      />
                      <FormControlLabel
                        value="2"
                        control={<Radio color="primary" />}
                        label={t('APPOINTMENTS.VACCINE_DOSE_SECOND')}
                      />
                    </RadioGroup>
                  </Grid>
                )}

              <Grid item md={3} lg={2} sm={4} xs={6}>
                <div>
                  <DropDownFieldValue
                    label={t('PATIENTS.DRAWER.AMOUNT_DUE')}
                    value={
                      <CurrencyFormatter
                        value={HelperUtils.getSumOfBalance(
                          appointmentObject?.patient?.guarantor_due || [],
                          'current_due_amount'
                        )}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                        ignoreRound={true}
                        useSign={true}
                      />
                    }
                  />
                </div>
              </Grid>
              <Grid item md={3} lg={2} sm={4} xs={6}>
                <DropDownFieldValue
                  label={t('APPOINTMENTS.COPAY_BALANCE')}
                  value={
                    <CurrencyFormatter
                      value={HelperUtils.getSumOfBalance(
                        appointmentObject?.patient?.misc_charge || [],
                        'charge_amount'
                      )}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'$'}
                      ignoreRound={true}
                      useSign={true}
                    />
                  }
                />
              </Grid>
              <Grid item md={3} lg={2} sm={4} xs={6}>
                <div style={{overflowWrap: 'break-word'}}>
                  <DropDownFieldValue
                    label={t('APPOINTMENTS.NOTES')}
                    value={appointmentObject?.notes || '-'}
                  />
                </div>
              </Grid>
              {/* Patient forums dropdown */}
              <Grid item md={3} lg={2} sm={4} xs={6}>
                {appointmentObject?.vaccine_id &&
                Object.values(AppointmentStatus).includes(
                  appointmentObject?.status
                ) ? (
                  <>
                    <DropDownFieldValue
                      label={t(
                        'APPOINTMENTS_SCHEDULAR_PORTAL.ADMIN_PORTAL.CONSENT_FORM'
                      )}
                      value={
                        <p className={classes.consentFormFieldWrapper}>
                          <span className={classes.LinkStyle}>
                            {t(
                              'APPOINTMENTS_SCHEDULAR_PORTAL.ADMIN_PORTAL.VIEW'
                            )}
                          </span>
                          <span className={classes.consentFormFieldAttention}>
                            {getConsentFormAttention()}
                          </span>
                        </p>
                      }
                      onClickAction={() =>
                        OnClickViewConsentFormDialog(appointmentObject?.id)
                      }
                    />
                    {!appointmentObject?.consent_reviewed_by ? (
                      <Grid item md={3} lg={2} sm={4} xs={6}>
                        <DropDownFieldValue
                          value={
                            <p style={{whiteSpace: 'nowrap'}}>
                              {t(
                                'APPOINTMENTS_SCHEDULAR_PORTAL.ADMIN_PORTAL.REVIEW_CONSENT_FORM'
                              )}
                            </p>
                          }
                          onClickAction={() => onClickReviewConsentFormDialog()}
                          valueStyles={classes.LinkStyle}
                        />
                      </Grid>
                    ) : (
                      t('APPOINTMENTS.CONSENT_REVIEWED', {
                        name:
                          HelperUtils.commaSeparatedFullName(
                            appointmentObject?.consent_reviewed_by_user
                              .first_name,
                            appointmentObject?.consent_reviewed_by_user
                              ?.last_name,
                            appointmentObject?.consent_reviewed_by_user
                              ?.middle_name
                          ) || '-'
                      })
                    )}
                  </>
                ) : (
                  <div>
                    {Permission.hasAppointmentPermissions(
                      userPermissions,
                      AppPermissions.APPOINTMENT.EDIT,
                      groupId
                    ) && (
                      <DropDownFieldValue
                        label={t('APPOINTMENTS.PATIENT_FORUMS')}
                        dropDown={renderDropDown(
                          patientFormsMapping,
                          FormUtils.getFieldName(
                            patientFormsMapping,
                            appointmentObject?.patient_forms
                          ),
                          (item: any) => {
                            handleDropDown('patient_forms', item);
                          },
                          'Patient Forms', // FIXME: TAKE TEXT FROM TRANSLATION
                          appointmentObject?.patient_forms
                        )}
                        valueStyles={classes.dropDown}
                      />
                    )}
                  </div>
                )}
              </Grid>
              {/* Verification status value */}
              {(isEligibilityVerificationEnabled ||
                appointmentObject.verification_status ===
                  VerificationStatusObj.VERIFIED) && (
                <Grid item md={3} lg={2} sm={4} xs={6}>
                  <DropDownFieldValue
                    label={t('APPOINTMENTS.VERIFICATION_STATUS')}
                    value={getVerificationStatusName()}
                  />
                </Grid>
              )}
              {/* Created at time value */}
              <Grid item md={3} lg={2} sm={4} xs={6}>
                <div style={{overflowWrap: 'break-word'}}>
                  <DropDownFieldValue
                    label={t('APPOINTMENTS.CREATED_ON')}
                    value={
                      appointmentObject?.created_at
                        ? HelperUtils.formatDisplayDateTime(
                            appointmentObject?.created_at
                          )
                        : '-'
                    }
                  />
                </div>
              </Grid>
              {/* Updated at time value */}
              <Grid item md={3} lg={2} sm={4} xs={6}>
                <div style={{overflowWrap: 'break-word'}}>
                  <DropDownFieldValue
                    label={t('APPOINTMENTS.UPDATED_ON')}
                    value={
                      appointmentObject?.modified_at
                        ? HelperUtils.formatDisplayDateTime(
                            appointmentObject?.modified_at
                          )
                        : '-'
                    }
                  />
                </div>
              </Grid>
              {Permission.hasAppointmentPermissions(
                userPermissions,
                AppPermissions.APPOINTMENT.EDIT,
                groupId
              ) &&
                isRmdAppointment &&
                (appointmentObject?.posted_to_emr ? (
                  <>
                    <Grid item md={3} lg={2} sm={4} xs={6}>
                      <DropDownFieldValue
                        label={t('PATIENTS.EMR_POSTED_STATUS_LABEL')}
                        value={
                          <div
                            style={{display: 'flex', flexWrap: 'wrap', gap: 4}}>
                            <EmrSyncStatusChip
                              entityType="appointment"
                              hasIntegration={Boolean(
                                appointmentObject?.emr_integration_enabled ??
                                  true
                              )}
                              postedToEmr={appointmentObject?.posted_to_emr}
                              awaitingEmrId={Boolean(
                                appointmentObject?.encounter_number &&
                                  !appointmentObject?.posted_to_emr
                              )}
                              jobState={appointmentObject?.emr_sync_state}
                              errorClass={
                                appointmentObject?.emr_sync_error_class
                              }
                              syncStatus={appointmentObject?.emr_sync_status}
                            />
                            <ArrivalChip
                              canonicalStatus={
                                appointmentObject?.canonical_status
                              }
                              arrivedAt={
                                appointmentObject?.arrived_at ||
                                appointmentObject?.status_changed_at
                              }
                            />
                          </div>
                        }
                      />
                    </Grid>
                    <Grid item md={3} lg={2} sm={4} xs={6}>
                      <DropDownFieldValue
                        label={t('PATIENTS.EMR_POSTED_BY')}
                        value={renderPostedByName()}
                      />
                    </Grid>
                    <Grid item md={3} lg={2} sm={4} xs={6}>
                      <DropDownFieldValue
                        label={t('PATIENTS.EMR_POSTED_ON')}
                        value={renderPostedOnDate()}
                      />
                    </Grid>
                  </>
                ) : (
                  <Grid item md={3} lg={2} sm={4} xs={6}>
                    <DropDownFieldValue
                      label={t('PATIENTS.EMR_POSTED_STATUS_LABEL')}
                      value={
                        <p
                          className={`${classes.LinkStyle} ${classes.wrapLink}`}
                          onClick={openPostToEmrDialog}
                          style={{
                            cursor: isPostingToEmr
                              ? 'wait'
                              : isPatientEmrSyncBlocked
                              ? 'not-allowed'
                              : 'pointer',
                            opacity:
                              isPostingToEmr || isPatientEmrSyncBlocked
                                ? 0.6
                                : 1,
                            margin: 0
                          }}>
                          {t('PATIENTS.MARK_POSTED_IN_EMR')}
                        </p>
                      }
                    />
                  </Grid>
                ))}
              {/* Eligibility status value */}
              {appointmentObject.verification_status ===
                VerificationStatusObj.VERIFIED &&
                !appointmentObject.is_manually_verified && (
                  <Grid item md={3} lg={2} sm={4} xs={6}>
                    <DropDownFieldValue
                      label={t('APPOINTMENTS.ELIGIBILITY_STATUS')}
                      value={mapEligibilityStatus().name || '-'}
                    />
                  </Grid>
                )}
              {/* Eligibility status dropdown */}
              {(!appointmentObject.patient_id ||
                appointmentObject.is_manually_verified ||
                (appointmentObject.verification_status ===
                  VerificationStatusObj.NOT_VERIFIED &&
                  !isEligibilityVerificationEnabled)) &&
                Permission.hasAppointmentPermissions(
                  userPermissions,
                  AppPermissions.APPOINTMENT.EDIT,
                  groupId
                ) && (
                  <Grid item md={3} lg={2} sm={4} xs={6}>
                    <DropDownFieldValue
                      label={t('APPOINTMENTS.ELIGIBILITY_STATUS')}
                      dropDown={renderDropDown(
                        eligibilityStatusMapping,
                        FormUtils.getFieldName(
                          eligibilityStatusMapping,
                          appointmentObject?.eligibility_status
                        ),
                        (item: any) => {
                          handleDropDown('eligibility_status', item);
                        },
                        t('APPOINTMENTS.ELIGIBILITY_STATUS'),
                        appointmentObject?.eligibility_status,
                        t('APPOINTMENTS.SELECT_ELIGIBILITY_STATUS')
                      )}
                      valueStyles={classes.dropDown}
                    />
                  </Grid>
                )}
              {/* Add insurance information link */}
              {canEnableAddInsuranceInformation && (
                <Grid item md={3} lg={2} sm={4} xs={6}>
                  <DropDownFieldValue
                    label={'\u00A0'}
                    value={
                      <p
                        className={`${classes.LinkStyle} ${classes.wrapLink}`}
                        onClick={async () => {
                          setShowManualVerificationDialog(true);
                        }}
                        style={{margin: 0}}>
                        {t(
                          'ELIGIBILITY_VERIFICATION.ADD_INSURANCE_INFORMATION'
                        )}
                      </p>
                    }
                  />
                </Grid>
              )}
              {/* View insurance details link */}
              {canEnableViewInsuranceDetails && (
                <Grid item md={3} lg={2} sm={4} xs={6}>
                  <DropDownFieldValue
                    label={'\u00A0'}
                    value={
                      <p
                        className={`${classes.LinkStyle} ${classes.wrapLink}`}
                        onClick={() => {
                          navigateToPatientEligibilityDrawer();
                        }}
                        style={{margin: 0}}>
                        {t('ELIGIBILITY_VERIFICATION.VIEW_INSURANCE_DETAILS')}
                      </p>
                    }
                  />
                </Grid>
              )}
              <Grid item md={3} lg={2} sm={4} xs={6}>
                <DropDownFieldValue
                  label={'\u00A0'}
                  value={
                    <VerifyInsurance
                      appointment={appointmentObject}
                      clinicGroupId={appointmentObject?.clinic_group_id}
                      clinicId={appointmentObject?.clinic_id}
                      patientId={appointmentObject?.patient_id}
                      hasCoverages={hasCoverages}
                      etaDate={appointmentObject?.coverage_eta_date}
                      isEligibilityVerificationEnabled={
                        isEligibilityVerificationEnabled
                      }
                      verifyingInsurance={verifyingInsurance}
                    />
                  }
                />
              </Grid>
              {appointmentObject?.status ===
                AppointmentStatus.COMPLETED_PCL && (
                <Grid item md={3} lg={2} sm={4} xs={6}>
                  <DropDownFieldValue
                    label={t('APPOINTMENTS.CLAIM_STATUS_LABEL')}
                    dropDown={renderDropDown(
                      claimsStatusMapping,
                      FormUtils.getFieldName(
                        claimsStatusMapping,
                        appointmentObject?.claim_status
                      ),
                      (item: any) => {
                        handleDropDown('claim_status', item);
                      },
                      t('APPOINTMENTS.CLAIM_STATUS_LABEL'),
                      appointmentObject?.claim_status,
                      t('APPOINTMENTS.SELECT_CLAIM_STATUS')
                    )}
                    valueStyles={classes.dropDown}
                  />
                </Grid>
              )}
              {appointmentObject?.status ===
                AppointmentStatus.COMPLETED_PCL && (
                <Grid item md={3} lg={2} sm={4} xs={6}>
                  <DropDownFieldValue
                    label={t('APPOINTMENTS.ACH_STATUS_LABEL')}
                    dropDown={renderDropDown(
                      achStatusMapping,
                      FormUtils.getFieldName(
                        achStatusMapping,
                        appointmentObject?.ach_status
                      ),
                      (item: any) => {
                        handleDropDown('ach_status', item);
                      },
                      t('APPOINTMENTS.ACH_STATUS_LABEL'),
                      appointmentObject?.ach_status,
                      t('APPOINTMENTS.SELECT_ACH_STATUS')
                    )}
                    valueStyles={classes.dropDown}
                  />
                </Grid>
              )}
              {/* Appointment Feedback Dropdown */}
              {appointmentFeedbackOptions.length > 0 &&
                hasPatientReviewPermission && (
                  <Grid item md={3} lg={2} sm={4} xs={6}>
                    {/* // appointmentObject?.is_review_sent} */}
                    {!appointmentObject?.review_status ? (
                      <DropDownFieldValue
                        label={t('APPOINTMENTS.FEEDBACK')}
                        dropDown={renderDropDown(
                          appointmentFeedbackOptions,
                          FormUtils.getFieldName(
                            appointmentFeedbackOptions,
                            appointmentObject?.review_type
                          ),
                          (item: any) => {
                            handleDropDown('review_type', item);
                          },
                          t('APPOINTMENTS.FEEDBACK'),
                          appointmentObject?.review_type,
                          t('APPOINTMENTS.SELECT_FEEDBACK'),
                          {
                            showClear: true,
                            onClear: () => {
                              const updatedAppointmentObj = {
                                ...appointmentObject
                              };
                              updatedAppointmentObj['review_type'] = '';
                              updateSelectedAppointment(
                                updatedAppointmentObj,
                                'review_type'
                              );
                            }
                          }
                        )}
                        valueStyles={classes.dropDown}
                      />
                    ) : (
                      <DropDownFieldValue
                        label={t('APPOINTMENTS.FEEDBACK')}
                        value={renderFeedBackSelectedValue()}
                      />
                    )}
                  </Grid>
                )}
              {appointmentObject?.vaccine_id &&
              Object.values(AppointmentStatus).includes(
                appointmentObject?.status
              ) ? (
                <Grid item md={3} lg={2} sm={4} xs={6}>
                  <DropDownFieldValue
                    label={t('APPOINTMENTS.CONSENT_FORM_REVIEW_NOTES')}
                    value={appointmentObject?.consent_review_notes || 'None'}
                  />
                </Grid>
              ) : (
                ''
              )}
              {appointmentObject?.eligibility_log_message &&
                doesUserHaveEligibilityPermission &&
                isEligibilityVerificationEnabled && (
                  <Grid item md={3} lg={2} sm={4} xs={6}>
                    <DropDownFieldValue
                      label={t('APPOINTMENTS.ELIGIBILITY_VERIFICATION_HISTORY')}
                      value={
                        <div>
                          {appointmentObject?.eligibility_log_message && (
                            <p>{appointmentObject?.eligibility_log_message}</p>
                          )}
                          <p
                            onClick={openVerificationLogDialog}
                            className={`${classes.LinkStyle} ${classes.wrapLink}`}>
                            {t('APPOINTMENTS.SHOW_VERIFICATION_HISTORY')}
                          </p>
                        </div>
                      }
                    />
                  </Grid>
                )}
              {shouldShowGuarantorInfoNeededChip ? (
                <Grid item xs={12} sm={12} md={4} lg={3}>
                  <div className="guarantor-info-needed-chip-cell">
                    <Chip
                      size="small"
                      className={classes.guarantorInfoNeededChip}
                      label={t('APPOINTMENT_FILTERS.PENDING_GUARANTOR_INFO')}
                    />
                  </div>
                </Grid>
              ) : null}
              {canCancelAppointment ? (
                <Grid item md={3} lg={2} sm={4} xs={6}>
                  <DropDownFieldValue
                    label={t('CLINICS.USER_DETAILS_TABLE.ACTION')}
                    value={
                      <p
                        className={classes.LinkStyle}
                        style={{margin: 0}}
                        onClick={() => setCancelDialogOpen(true)}>
                        {t('APPOINTMENTS.CANCEL_APPOINTMENT')}
                      </p>
                    }
                  />
                </Grid>
              ) : null}
            </>
          )}
        </Grid>
      </div>
    </>
  );

  const renderOverlayDialogs = (): ReactElement => (
    <>
      <Dialog
        open={completeVaccineDialog.open}
        onClose={() =>
          setCompleteVaccineDialog(d => ({
            ...d,
            open: false
          }))
        }
        maxWidth="sm"
        fullWidth>
        <DialogTitle>{t('APPOINTMENTS.COMPLETE_VACCINE_TITLE')}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" gutterBottom>
            {completeVaccineDialog.promptDose &&
            completeVaccineDialog.promptAddress
              ? t('APPOINTMENTS.COMPLETE_VACCINE_CONFIRM_BOTH')
              : completeVaccineDialog.promptDose
              ? t('APPOINTMENTS.COMPLETE_VACCINE_CONFIRM_DOSE_ONLY')
              : t('APPOINTMENTS.COMPLETE_VACCINE_CONFIRM_ADDRESS_ONLY')}
          </Typography>
          {completeVaccineDialog.promptDose && (
            <>
              <Typography variant="subtitle2" style={{marginTop: 12}}>
                {t('APPOINTMENTS.VACCINE_DOSE')}
              </Typography>
              <RadioGroup
                row
                value={
                  completeVaccineDialog.dose === 1 ||
                  completeVaccineDialog.dose === 2
                    ? String(completeVaccineDialog.dose)
                    : ''
                }
                onChange={e =>
                  setCompleteVaccineDialog(d => ({
                    ...d,
                    dose: parseInt(e.target.value, 10) as 1 | 2
                  }))
                }>
                <FormControlLabel
                  value="1"
                  control={<Radio color="primary" />}
                  label={t('APPOINTMENTS.VACCINE_DOSE_FIRST')}
                />
                <FormControlLabel
                  value="2"
                  control={<Radio color="primary" />}
                  label={t('APPOINTMENTS.VACCINE_DOSE_SECOND')}
                />
              </RadioGroup>
            </>
          )}
          {completeVaccineDialog.promptAddress && (
            <>
              <Typography variant="body2" style={{marginTop: 16}}>
                {t('APPOINTMENTS.ADDRESS_REQUIRED_FOR_CLAIM')}
              </Typography>
              <TextField
                fullWidth
                margin="dense"
                label={t('ADD_PATIENT.ADDRESS_LINE_1')}
                value={completeVaccineDialog.address_line_1}
                onChange={e =>
                  setCompleteVaccineDialog(d => ({
                    ...d,
                    address_line_1: e.target.value
                  }))
                }
              />
              <TextField
                fullWidth
                margin="dense"
                label={t('ADD_PATIENT.CITY')}
                value={completeVaccineDialog.city}
                onChange={e =>
                  setCompleteVaccineDialog(d => ({
                    ...d,
                    city: e.target.value
                  }))
                }
              />
              <TextField
                fullWidth
                margin="dense"
                label={t('ADD_PATIENT.STATE')}
                value={completeVaccineDialog.state}
                onChange={e =>
                  setCompleteVaccineDialog(d => ({
                    ...d,
                    state: e.target.value
                  }))
                }
              />
              <TextField
                fullWidth
                margin="dense"
                label={t('ADD_PATIENT.ZIP_CODE')}
                value={completeVaccineDialog.zip_code}
                onChange={e =>
                  setCompleteVaccineDialog(d => ({
                    ...d,
                    zip_code: e.target.value
                  }))
                }
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setCompleteVaccineDialog(d => ({
                ...d,
                open: false
              }))
            }>
            {t('COMMON.CANCEL')}
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={confirmCompleteVaccine}>
            {t('COMMON.CONFIRM')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={cancelDialogOpen}
        onClose={closeCancelDialog}
        maxWidth="sm"
        fullWidth>
        <DialogTitle>
          {t('APPOINTMENTS.CANCEL_APPOINTMENT_CONFIRM_TITLE')}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" gutterBottom>
            {t('APPOINTMENTS.CANCEL_APPOINTMENT_CONFIRM', {
              patient:
                HelperUtils.commaSeparatedFullName(
                  appointmentObject?.patient?.first_name,
                  appointmentObject?.patient?.last_name,
                  appointmentObject?.patient?.middle_name
                ) || t('COMMON.NONE_VALUE')
            })}
          </Typography>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            label={t('APPOINTMENTS.CANCEL_APPOINTMENT_REASON_LABEL')}
            value={cancelReason}
            onChange={e => setCancelReason(e.target.value)}
            disabled={cancellingAppointment}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeCancelDialog} disabled={cancellingAppointment}>
            {t('COMMON.CLOSE')}
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => void handleCancelAppointment()}
            disabled={cancellingAppointment || !cancelReason.trim()}>
            {t('APPOINTMENTS.CANCEL_APPOINTMENT')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={postToEmrDialog.open}
        onClose={closePostToEmrDialog}
        maxWidth="sm"
        fullWidth>
        <DialogTitle>{t('APPOINTMENTS.POST_TO_EMR_DIALOG_TITLE')}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" gutterBottom>
            {t('APPOINTMENTS.POST_TO_EMR_DIALOG_SUBTITLE')}
          </Typography>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            label={t('APPOINTMENTS.APPOINTMENT_ENCOUNTER')}
            value={postToEmrDialog.encounterNumber}
            onChange={e =>
              setPostToEmrDialog(d => ({
                ...d,
                encounterNumber: sanitizeEmrAlphanumericInput(e.target.value)
              }))
            }
            onKeyDown={e => {
              if (e.key === 'Enter' && !isPostingToEmr) {
                handleMarkPostedToEmr();
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closePostToEmrDialog} disabled={isPostingToEmr}>
            {t('COMMON.CANCEL')}
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={handleMarkPostedToEmr}
            disabled={isPostingToEmr}>
            {t('COMMON.SAVE')}
          </Button>
        </DialogActions>
      </Dialog>
      {guarantorValues?.guarantorDrawerOpen && (
        <GuarantorDrawerComponent
          open={guarantorValues?.guarantorDrawerOpen}
          closeDrawer={closeGuarantorDrawer}
          guarantorId={guarantorValues?.guarantorId}
          guarantorName={guarantorValues?.guarantorName}
          clinicId={patientDetailsDrawer?.clinicId}
          patientDrawerLinkBoolean={false}
        />
      )}
      {showManualVerificationDialog && (
        <ManualVerificationModal
          isOpen={showManualVerificationDialog}
          handleClose={() => setShowManualVerificationDialog(false)}
          appointmentId={appointmentObject?.id}
          clinicGroupId={appointmentObject?.clinic_group_id}
          clinicId={appointmentObject?.clinic_id}
          onSuccess={() => {
            // DISPATCH TO REFRESH THE APPOINTMENT
            CommunicationService.sendEvent({
              action: 'REFRESH_APPOINTMENT',
              data: {
                clinicGroupId: appointmentObject?.clinic_group_id,
                clinicId: appointmentObject?.clinic_id,
                appointmentId: appointmentObject?.id
              }
            });
          }}
        />
      )}
      {isVerificationLogDialogOpen && (
        <EligibilityVerificationLogs
          open={isVerificationLogDialogOpen}
          onClose={closeVerificationLogDialog}
          appointmentId={appointmentObject.id}
          groupId={appointmentObject?.clinic_group_id}
          clinicId={appointmentObject?.clinic_id}
        />
      )}
      {viewPDF && renderViewConsentFormDialog()}
      {/* {renderViewPdfViewer()} */}
      {consentFormReview && renderReviewConsentFormDialog()}
    </>
  );

  if (isInlineDisplay) {
    return (
      <>
        <div
          id={id}
          className="appointments-card-detail-wrapper appointments-card-detail-wrapper--inline"
          style={appointmentCardStyle}>
          {renderCardBody()}
        </div>
        {renderOverlayDialogs()}
      </>
    );
  }

  return (
    <>
      <Paper
        id={id}
        elevation={1}
        className={[
          'appointments-card-detail-wrapper',
          !showFullDetails ? 'appointments-card-detail-wrapper--expandable' : ''
        ].join(' ')}
        style={appointmentCardStyle}
        variant="outlined"
        onClick={handleCardClick}>
        {renderCardBody()}
      </Paper>
      {renderOverlayDialogs()}
    </>
  );
};
export default AppointmentCardDetails;
